var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var IpcSmdPadGeneratorInteractionModel = require('../ipcSmdPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var ChipArrayTwoSideFlatConcavePadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    IpcSmdPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(ChipArrayTwoSideFlatConcavePadGeneratorInteractionModel, IpcSmdPadGeneratorInteractionModel);
ChipArrayTwoSideFlatConcavePadGeneratorInteractionModel.$class = 'ChipArrayTwoSideFlatConcavePadGeneratorInteractionModel';

module.exports = ChipArrayTwoSideFlatConcavePadGeneratorInteractionModel;

ChipArrayTwoSideFlatConcavePadGeneratorInteractionModel.prototype.initialize = function() {
    var self = this;

    IpcSmdPadGeneratorInteractionModel.prototype.initialize.call(this);

    this.componentFamily = this.shadow("componentFamily",
        function() {
            return self.data.componentFamily();
        },
        function(value) {
            return self.data.componentFamily(value);
        },
        [self.data.componentFamily]
    );

    this.leadShapeType = this.shadow("leadShapeType",
        function() {
            return self.data.leadShapeType();
        },
        function(value) {
            return self.data.leadShapeType(value);
        },
        [self.data.leadShapeType]
    );
};

ChipArrayTwoSideFlatConcavePadGeneratorInteractionModel.prototype.getInspectorElementForLeadShapeType = function() {
    var leadShapeTypesList = [];

    for (var t in cio_datamodel.IpcDataModel.ComponentAttribute.chipArrayLeadShapeType) {
        var c = cio_datamodel.IpcDataModel.ComponentAttribute.chipArrayLeadShapeType[t];
        leadShapeTypesList.push([this.LCLZ(t, c), c]);
    }

    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('leadShape', 'Lead Shape'), this.leadShapeType, leadShapeTypesList)];
};


ChipArrayTwoSideFlatConcavePadGeneratorInteractionModel.prototype.getInspectorElementForComponentFamily = function() {
    var componentFamilyList = [];

    for (var t in cio_datamodel.IpcDataModel.ComponentAttribute.chipArrayComponentFamily.FLAT_CONCAVE) {
        var c = cio_datamodel.IpcDataModel.ComponentAttribute.chipArrayComponentFamily.FLAT_CONCAVE[t];
        componentFamilyList.push([this.LCLZ(t, c), c]);
    }

    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('componentFamily', 'Component Family'), this.componentFamily, componentFamilyList)];
};

ChipArrayTwoSideFlatConcavePadGeneratorInteractionModel.prototype.getInspectorElementForPadCount = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('#Pins', '# Pins'), this.horizontalPadCount, [4, 6, 8, 10, 16])];
};

ChipArrayTwoSideFlatConcavePadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

ChipArrayTwoSideFlatConcavePadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintChipArray2SideFlat));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForPadGapInCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForComponentFamily());
    imElements = imElements.concat(this.getInspectorElementForPadCount());
    imElements = imElements.concat(this.getInspectorElementForLeadShapeType());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};